import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import componentRelatedUser from '~/components/related-user.vue';
import componentRelatedFile from '~/components/related-document.vue';
import modal from '~/components/modal.vue';
import tabs from '~/components/tab/tabs.vue';
import grantchart from '~/components/grantchart.vue';
import grantchartQU from '~/components/grantchartQU.vue';
import tab from '~/components/tab/tab.vue';
import chat from '~/components/chat.vue';
import API from '~/api/api.js';
import chatFull from '~/components/chat-full-box.vue';
import upload from '~/components/upload.vue';

var miniToastr = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
}
var userData = '';
export default {
  middleware: ['auth', 'authorizeCustomer'],
  mounted: function mounted() {
    miniToastr.init();
  },

  notifications: {
    showLoginError: {
      title: '',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          params = _ref.params,
          redirect = _ref.redirect,
          error = _ref.error;
      var l, value1, value2, messageResponse, messages, detail, listQU, lastQU, valueLast, valueQU, valueEn, personData, personInChat, teamMember;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              l = store.state.authUser;

              userData = l;
              _context.next = 4;
              return API.setToken(userData.tokenID);

            case 4:
              _context.next = 6;
              return API.getProject(params.id);

            case 6:
              value1 = _context.sent;

              if (!(value1.data.flag === false)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt('return', error({ message: value1.data.message, statusCode: '401' }));

            case 9:
              _context.next = 11;
              return API.listTaskOfProject(params.id);

            case 11:
              value2 = _context.sent;
              _context.next = 14;
              return API.getMessage(params.id);

            case 14:
              messageResponse = _context.sent;
              messages = messageResponse.data.datas;
              detail = value1.data.datas;
              listQU = [];
              lastQU = null;
              // let lastQU = []

              _context.next = 21;
              return API.GetLastQU(params.id);

            case 21:
              valueLast = _context.sent;


              lastQU = valueLast.data.datas;

              _context.next = 25;
              return API.GetQUOfProject(params.id);

            case 25:
              valueQU = _context.sent;

              listQU = valueQU.data.datas;

              _context.next = 29;
              return API.GetEngineerOfProject(params.id);

            case 29:
              valueEn = _context.sent;
              _context.next = 32;
              return API.getPersonInProject(params.id);

            case 32:
              personData = _context.sent;
              personInChat = personData.data.datas;
              // let teamMemberDev = valueEn.data.datas.map(task => task.id + 'test')

              teamMember = valueEn.data.datas.map(function (item) {
                if (item.id === detail.ownerID) {
                  item.isOwner = true;
                } else {
                  item.isOwner = false;
                }
                return item;
              });
              return _context.abrupt('return', {
                ProjectDetail: detail,
                personInChat: personInChat,
                ProductionTask: value2.data.datas,
                task: value2.data.datas,
                projectID: params.id,
                projectFiles: detail.pro_attach_files,
                time: new Date(),
                userData: userData,
                messages: messages,
                message: '',
                listQU: listQU,
                lastQU: lastQU,
                allPersonInProject: teamMember,
                listEngOfProject: valueEn.data.datas.filter(function (o) {
                  return o.role === 'Engineer';
                }),
                taskNew: value2.data.datas.filter(function (o) {
                  return o.prodTaskStatus === 'New';
                }),
                taskAnswer: value2.data.datas.filter(function (o) {
                  return o.prodTaskStatus === 'Answer';
                }),
                taskReject: value2.data.datas.filter(function (o) {
                  return o.prodTaskStatus === 'Reject';
                })
              });

            case 36:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      jobNumber: '',
      openAcceptProject: false,
      openActKnowledge: false,
      openAssignJob: false,
      openReminder: false,
      openEngineer: false,
      openDelete: false,
      openSetAct: false,
      openComplete: false,
      ProjectDetail: null,

      openAcceptTask: false,
      counter: 0,
      engineer: '',
      filterEngineer: '',
      statusDatas: ['New', 'Quoting', 'Quoted', 'Working', 'Complete'],
      indexStatus: 0
    };
  },

  methods: {
    uploadPO: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var items, formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, result;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                items = this.$refs.upload.getItems();
                formData = new FormData(); // Currently empty

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 7;
                for (_iterator = _getIterator(items); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  file = _step.value;

                  formData.append('fileUpload', file.file, file.file.name);
                }
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 15:
                _context2.prev = 15;
                _context2.prev = 16;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 18:
                _context2.prev = 18;

                if (!_didIteratorError) {
                  _context2.next = 21;
                  break;
                }

                throw _iteratorError;

              case 21:
                return _context2.finish(18);

              case 22:
                return _context2.finish(15);

              case 23:
                _context2.next = 25;
                return API.UploadPOCustomer(this.projectID, formData);

              case 25:
                result = _context2.sent;

                if (result.data.flag) {
                  this.showSuccess({ message: 'Alredy Upload PO' });
                  window.location.reload();
                } else {
                  this.showLoginError({ message: result.data.message });
                }

              case 27:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 11, 15, 23], [16,, 18, 22]]);
      }));

      function uploadPO() {
        return _ref3.apply(this, arguments);
      }

      return uploadPO;
    }(),

    createQUStatus: function createQUStatus(quStatus) {
      return 'lbl lbl-status-' + quStatus;
    },
    CreateUrlQUDetail: function CreateUrlQUDetail(quNo, revise, projectID) {
      return '/project/quotation/?quNo=' + quNo + '&revise=' + revise + '&projectID=' + projectID;
    },
    acceptQU: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(quNo, revise) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context3.next = 4;
                return API.AcceptQU(quNo, revise);

              case 4:
                result = _context3.sent;


                if (result !== undefined) {
                  if (result.data.flag) {
                    this.showSuccess({ message: 'Alredy Accept QU' });
                    window.location.reload();
                  } else {
                    this.showLoginError({ message: result.data.message });
                  }
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function acceptQU(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return acceptQU;
    }(),
    scrollToBottom: function scrollToBottom() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.messages.scrollTop = _this.$refs.messages.scrollHeight;
      });
    },
    showModelAccept: function showModelAccept() {
      this.openAcceptProject = true;
    },
    showModelConfirm: function showModelConfirm() {
      this.openActKnowledge = true;
    },
    showEngineers: function showEngineers() {
      this.openEngineer = true;
    },
    showDelete: function showDelete() {
      this.openDelete = true;
    },
    showModalAssign: function showModalAssign() {
      this.openAssignJob = true;
    },
    showModalReminder: function showModalReminder() {
      this.openReminder = true;
    },

    createlbl: function createlbl(status) {
      return 'is-lbl is-status-' + status;
    },
    acknowledge: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var results;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context4.next = 4;
                return API.acknowledge(this.projectID, {
                  acceptMessage: 'YES'
                });

              case 4:
                results = _context4.sent;

                if (results.data.flag) {
                  this.showSuccess({ message: results.data.message });
                } else {
                  this.showLoginError({ message: results.data.message });
                }

                this.openActKnowledge = false;

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function acknowledge() {
        return _ref5.apply(this, arguments);
      }

      return acknowledge;
    }(),
    accept: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var results;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context5.next = 4;
                return API.Accept(this.projectID);

              case 4:
                results = _context5.sent;

                if (results !== undefined) {
                  this.openAssignJob = false;
                  if (results.data.flag) {
                    this.showSuccess({ message: results.data.message });
                  } else {
                    this.showLoginError({ message: results.data.message });
                  }

                  // window.location.reload()
                }

                window.location.reload();

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function accept() {
        return _ref6.apply(this, arguments);
      }

      return accept;
    }(),
    createUrlTask: function createUrlTask(id) {
      return '/project/tasks/' + id;
    },
    isCheck: function isCheck(isFinal) {
      if (isFinal === 'Yes') {
        return 'checked';
      }
      return false;
    },
    clickCheckBox: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(index) {
        var obj, prevStatus, results, _index;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                obj = this.ProductionTask[index];
                prevStatus = obj.isFinal;

                if (obj.isFinal === 'Yes') {
                  obj.isFinal = 'No';
                } else {
                  obj.isFinal = 'Yes';
                }

                _context6.next = 5;
                return API.setToken(this.userData.tokenID);

              case 5:
                _context6.next = 7;
                return API.putTaskToFinal(obj.prodTaskID);

              case 7:
                results = _context6.sent;

                if (results.data.flag) {
                  this.showSuccess({ message: results.data.message });
                  if (obj.isFinal === 'Yes') {
                    this.finalTask.push(obj);
                  } else {
                    _index = this.finalTask.indexOf(obj);

                    if (_index !== -1) {
                      this.finalTask.splice(_index, 1);
                    }
                  }
                } else {
                  this.showLoginError({ message: results.data.message });
                  obj.isFinal = prevStatus;
                }

                return _context6.abrupt('return', true);

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function clickCheckBox(_x4) {
        return _ref7.apply(this, arguments);
      }

      return clickCheckBox;
    }(),
    showActual: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context7.next = 4;
                return API.GetFinalTask(this.projectID);

              case 4:
                result = _context7.sent;

                this.finalTask = result.data.datas;
                this.openSetAct = true;

              case 7:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function showActual() {
        return _ref8.apply(this, arguments);
      }

      return showActual;
    }(),
    saveActual: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var results, result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context8.next = 4;
                return API.UpdateActualTask(this.finalTask);

              case 4:
                results = _context8.sent;

                if (results.data.flag) {
                  this.showSuccess({ message: results.data.message });
                } else {
                  this.showLoginError({ message: results.data.message });
                }
                _context8.next = 8;
                return API.GetFinalTask(this.projectID);

              case 8:
                result = _context8.sent;

                this.finalTask = result.data.datas;
                this.openSetAct = false;
                // window.location.reload()

              case 11:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function saveActual() {
        return _ref9.apply(this, arguments);
      }

      return saveActual;
    }(),
    createUrlQU: function createUrlQU() {
      return '/project/quotation/create/?projectID=' + this.projectID;
    }
  },
  components: {
    componentRelatedUser: componentRelatedUser,
    componentRelatedFile: componentRelatedFile,
    tabs: tabs,
    tab: tab,
    chat: chat,
    modal: modal,
    grantchart: grantchart,
    grantchartQU: grantchartQU,
    chatFull: chatFull,
    upload: upload
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/customer/project/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/customer/project/_id.vue
// module chunks = 1